module.exports = __webpack_public_path__ + "static/media/021.02b2fc44.png";